import { z } from 'zod';
// Local org-scoped audit-trail query for GET /api/admin/audit.
// Distinct from fleet-audit.ts (which mirrors edge rows into central):
// this reads the LOCAL audit_log on whatever deployment serves the request,
// and accepts the FULL audit_action enum for filtering (fleet-audit only
// allows the 6 sync-replicated actions).
export const AUDIT_ACTIONS = [
    'create',
    'update',
    'delete',
    'login',
    'logout',
    'read',
    'install',
    'rollback',
    'pdf_persist',
    'pdf_access',
    'archive',
    'unarchive',
    'purge',
    'legal_hold_set',
    'legal_hold_clear',
    'csv_import',
    'csv_export',
    'hold_set',
    'hold_clear',
    'consent_grant',
    'consent_revoke',
    'disclosure_record',
    'hipaa_export',
    'impersonation_start',
    'impersonation_end',
    'import',
];
export const auditQuerySchema = z.object({
    entityType: z.string().max(50).optional(),
    entityId: z.string().max(255).optional(),
    action: z.enum(AUDIT_ACTIONS).optional(),
    // Free-text match against changed_by_name OR changed_by_id.
    changedBy: z.string().max(255).optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
//# sourceMappingURL=audit.js.map